import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');
class Callusnow extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          	loaded: true,
            languagedata:[],
			defaultlang:6,
          	Siteconfig:[],

			
			
        };
		
    }
componentDidMount() {
  	const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});


    if(localStorage.getItem('SiteconfigObj')!=null){
      const SiteconfigObj=JSON.parse(localStorage.getItem('SiteconfigObj'));
       this.setState({Siteconfig:SiteconfigObj});
  }else{
  this.getsiteconfig(DefaultLang);
  }


}	
getsiteconfig(DefaultLang){
      axios.post(`${API_URL}/siteconfig`, { LanguageId : 6}).then(res => {
            if(res.data.Status == 1)
            {
              const Siteconfig = res.data.ResponseData[0];
               localStorage.setItem('SiteconfigObj',JSON.stringify(Siteconfig));
              this.setState({ Siteconfig });
              
            }else{
              this.setState({ Siteconfig:[] });
            }
            
        })
    }

  render() {
	  
	 return (
      <div className="container">
		<div className="row">
		<div className="col-12">
		  <div className="callus_now">
		    <div className="row">
		      <div className="col-xl-2 col-lg-2 col-md-2">
		        <img src={ IMAGE_URL+'/images/phone.png' } alt="Call-us-now" />
		      </div>
		      <div className="col-xl-6 col-lg-6 col-md-5">
		        <span>{this.props.languagedata.call_us_now}</span>
		        <p>{this.props.languagedata.call_us_now_text}</p>
		      </div>
		      <div className="col-xl-4 col-lg-4 col-md-5">
		        <a href={ "tel:"+this.state.Siteconfig.Phone}>{this.state.Siteconfig.Phone}</a>
		      </div>
		    </div>    
		  </div>
		</div>
		</div>
	  </div>
		
    );
  }
}

export default Callusnow;



// WEBPACK FOOTER //
// ./src/component/Callusnow.js